import * as React from 'react';
import { Grid } from '@mui/material';
import RecipeReviewCard from './Card';
import { obtenerRegistrosPersonalizadoPublic } from 'store/actions/customAction';
import { alertaPersonalizadaSwal } from 'servicios/AlertasPersonalizados';
import { useDispatch } from 'react-redux';
import { useState } from 'react';
import IndicadorDeCarga from 'components/IndicadorDeCarga';
import ServiciosDelAPI from 'servicios/ServiciosDelAPI';
import ListadoDeEmpresasPorCobertura from './ListadoDeEmpresasPorCobertura';
import { functions } from 'constantes';
import { reportes } from 'constantes/reportes';

const CatalogosDeMedios = () => {

  const dispatch = useDispatch();
  const [catalogoDeMediosPublicos] = useState("catalogoDeMediosPublicos");
  const listadoDeOpciones = [
    { "id": 1, "descripcion": "COBERTURA NACIONAL"}, { "id": 2, "descripcion": "COBERTURA REGIONAL" },
    { "id": 3, "descripcion": "COBERTURA DEPARTAMENTAL" }, {"id": 4,"descripcion": "COBERTURA MUNICIPAL"}
  ]
  const listadoDeOpcionesAlternativos = [
    { "id": 4, "descripcion": "PANTALLA DIGITALES"}, { "id": 5, "descripcion": "VALLAS FIJAS" },
    { "id": 6, "descripcion": "VALLAS MÓVILES" },
    { "id": 7, "descripcion": "DESCARGAR FORMULARIO SOLICITUD DE VALLAS" },
    { "id": 8, "descripcion": "INSTRUCTIVO DE PLAN DE MEDIOS ALTERNATIVOS" }
  ]
  const[cargandoSolicitud, setcargandoSolicitud] = useState(false);
  const[mostrarListadoEmpresas, setMostrarListadoEmpresas] = useState(false);
  const[datosDelMedio, setDatosDelMedio] = useState({});
  const[datosDeLasEmpresas, setDatosDeLasEmpresas] = useState([]);

  const handleClick = async (tipoDeMedioDeComunicacion, item, tipoDelMedio) => {
    setcargandoSolicitud(true);
    ServiciosDelAPI[catalogoDeMediosPublicos].setearMetodoPublico(true);
    let respuesta = await dispatch(obtenerRegistrosPersonalizadoPublic({
        controller: catalogoDeMediosPublicos,
        saveInStore: false,
        nombreDelMetodo: `listar/filtarEmpresasCuandoExistaTipoDeMedioYTipoDeCobertura/${item?.id || ""}/${tipoDeMedioDeComunicacion.id}` ,
    }));

    setcargandoSolicitud(false);
    if(respuesta?.error) return alertaPersonalizadaSwal( respuesta?.error?.message || 'No se pudó obtener los datos');
    if(respuesta?.data?.length === 0) return alertaPersonalizadaSwal( "" || 'No existen datos para este medio');

    setDatosDelMedio({tipoDeMedioDeComunicacion, cobertura: item});
    setDatosDeLasEmpresas(respuesta?.data || []);
    setMostrarListadoEmpresas(true);
  }

  const descargarFormularioDeVallas = () => functions.descargarBase64EnPDF(reportes.reporteFormularioDeVallas, "Formato_Contratación_de_medios_alternativos.xlsx")
  const descargareInstructivoPlanDeMedios = () => functions.descargarBase64EnPDF(reportes.reporteInstructivoPlanDeMedios, "Instructivo_de_plan_de_medios_alternativos.docx")

  const handleClickAlternativos = async (tipoDeMedioDeComunicacion, item) => {
    // console.log("tipo", tipoDeMedioDeComunicacion, item)
    if(item.id === 7) return descargarFormularioDeVallas();
    if(item.id === 8) return descargareInstructivoPlanDeMedios();
    setcargandoSolicitud(true);
    ServiciosDelAPI[catalogoDeMediosPublicos].setearMetodoPublico(true);
    let respuesta = await dispatch(obtenerRegistrosPersonalizadoPublic({
        controller: catalogoDeMediosPublicos,
        saveInStore: false,
        nombreDelMetodo: `listar/filtarEmpresasCuandoExistaTipoDeMedioYTipoDeCobertura/${tipoDeMedioDeComunicacion.id || ""}/${item?.id}` ,
    }));

    setcargandoSolicitud(false);
    if(respuesta?.error) return alertaPersonalizadaSwal( respuesta?.error?.message || 'No se pudó obtener los datos');
    if(respuesta?.data?.length === 0) return alertaPersonalizadaSwal( "" || 'No existen datos para este medio');

    setDatosDelMedio({tipoDeMedioDeComunicacion: item, cobertura: {"id": 4,"descripcion": ""}});
    setDatosDeLasEmpresas(respuesta?.data || []);
    setMostrarListadoEmpresas(true);
  }

  const cerrarModal= () => setMostrarListadoEmpresas(false);

  return (
    <>
      {cargandoSolicitud ? <IndicadorDeCarga open={cargandoSolicitud} /> : '' }
      <Grid container justifyContent={"center"} alignItems={"center"} spacing={1} style={{marginTop: '70px'}} >
        <RecipeReviewCard handleClick={handleClick} imagen={"/menu/television.png"} tipoDeMedioDeComunicacion={{"id": 1, "descripcion": "TELEVISIÓN"}} listadoDeOpciones={listadoDeOpciones} tipoDelMedio="television" />
        <RecipeReviewCard handleClick={handleClick} imagen={"/menu/radio.png"} tipoDeMedioDeComunicacion={{"id": 2, "descripcion": "RADIO"}} listadoDeOpciones={listadoDeOpciones} tipoDelMedio="radio" />
        <RecipeReviewCard handleClick={handleClick} imagen={"/menu/escritos.png"} tipoDeMedioDeComunicacion={{"id": 3, "descripcion": "ESCRITOS"}} listadoDeOpciones={listadoDeOpciones} tipoDelMedio="escritos" />
        <RecipeReviewCard handleClick={handleClickAlternativos} imagen={"/menu/vallas_fijas.png"} tipoDeMedioDeComunicacion={{"id": 4, "descripcion": "Medios Alternativos"}} listadoDeOpciones={listadoDeOpcionesAlternativos}/>
        {/* <RecipeReviewCard handleClick={handleClick} imagen={"/menu/pantalla_digital.png"} tipoDeMedioDeComunicacion={{"id": 5, "descripcion": "PANTALLAS"}} listadoDeOpciones={listadoDeOpciones}/> */}
      </Grid>

      {mostrarListadoEmpresas && (
        <ListadoDeEmpresasPorCobertura
            openFullScreenDialog={mostrarListadoEmpresas}
            handleClose={cerrarModal}
            title={"Formulario para agregar nuevo usuario"}
            datosDelMedio={datosDelMedio}
            datosDeLasEmpresas={datosDeLasEmpresas}
        />
      )}
    </>
  );
}

export default CatalogosDeMedios;